import { render, staticRenderFns } from "./CustomersContactForm.vue?vue&type=template&id=d2aefd52&"
import script from "./CustomersContactForm.vue?vue&type=script&lang=ts&"
export * from "./CustomersContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports